import React from 'react';
import PropTypes from 'prop-types';
import { Col, Collapse, Row, Tabs, Spin } from 'antd';
import LocationTab from '../../../containers/targeting/LocationTab';
import AppTab from '../../../containers/targeting/AppTab';
import ChainTab from '../../../containers/targeting/ChainTab';
import StateTab from '../../../containers/targeting/StateTab';
import BeaconTab from '../../../containers/targeting/BeaconTab';
import AudienceTab from '../../../containers/AudienceTab';
import AudienceForecastTab from '../../../containers/forecast/AudienceForecastTab';
import AlcoholTab from '../../../containers/targeting/AlcoholTab';
import LineItemAppList from '../../../containers/campaign/lineitem/LineItemAppList';
import LineItemLocationList from '../../../containers/campaign/lineitem/LineItemLocationList';
import LineItemStateList from '../../../containers/campaign/lineitem/LineItemStateList';
import LineItemBeaconList from '../../../containers/campaign/lineitem/LineItemBeaconList';
import DmaTab from '../../../containers/targeting/DmaTab';

const tabs = [
  { title: 'App', id: 'App', component: AppTab },
  { title: 'Audience', id: 'Audience', component: AudienceTab },
  { title: 'Audience', id: 'AudienceForecast', component: AudienceForecastTab },
  { title: 'Chain', id: 'Chain', component: ChainTab },
  { title: 'State', id: 'State', component: StateTab },
  { title: 'DMA', id: 'Dma', component: DmaTab },
  { title: 'Location', id: 'Location', component: LocationTab },
  { title: 'Beacon', id: 'Beacon', component: BeaconTab },
  { title: 'Alcohol & Age Restrictions', id: 'Alcohol & Age Restrictions', component: AlcoholTab },
];

const tables = [
  { title: 'App', component: LineItemAppList },
  { title: 'Location', component: LineItemLocationList },
  { title: 'State', component: LineItemStateList },
  { title: 'Beacon', component: LineItemBeaconList },
];

const TargetingTab = ({ isPolling, changeActiveKey, headerLengths, activeMenus, allowedTabs }) => (
  <>
    <Tabs type="card">
      {tabs.map(tab => {
        let { title } = tab;
        if (tab.id === 'Audience') {
          title = [
            isPolling && <Spin size="small" style={{ marginRight: 10 }} />,
            <span>Audience</span>,
          ];
        }

        return (
          allowedTabs.includes(tab.id) && (
            <Tabs.TabPane forceRender tab={title} key={tab.title}>
              <tab.component />
            </Tabs.TabPane>
          )
        );
      })}
    </Tabs>

    <Row style={{ marginTop: 20 }}>
      <Col>
        <Collapse bordered={false} onChange={changeActiveKey} activeKey={activeMenus}>
          {tables.map(
            table =>
              allowedTabs.includes(table.title) && (
                <Collapse.Panel
                  header={(() => {
                    if (table.title === 'Location') {
                      return `Location - ${headerLengths.Location} / Chain - ${headerLengths.Chain}`;
                    }
                    if (table.title === 'State') {
                      return `State - ${headerLengths.State} / DMA - ${headerLengths.Dma}`;
                    }

                    return `${table.title} - ${headerLengths[table.title]}`;
                  })()}
                  key={table.title}
                  forceRender
                >
                  <table.component />
                </Collapse.Panel>
              )
          )}
        </Collapse>
      </Col>
    </Row>
  </>
);

TargetingTab.defaultProps = {
  isPolling: PropTypes.bool,
  allowedTabs: [
    'Alcohol & Age Restrictions',
    'App',
    'Audience',
    'Chain',
    'State',
    'Dma',
    'Location',
    'Beacon',
  ],
};

TargetingTab.propTypes = {
  isPolling: false,
  allowedTabs: PropTypes.arrayOf([
    'AudienceForecast',
    'Alcohol & Age Restrictions',
    'App',
    'Audience',
    'Chain',
    'State',
    'Dma',
    'Location',
    'Beacon',
  ]),
};

export default TargetingTab;
